import React from 'react';
import { campanhaNatalAtiva } from '../utils/campanhas';
import { linkWhatsApp, MENSAGEM_VALE_PRESENTE } from '../utils/contactos';
import { registarEvento } from '../utils/analytics';

// Secção de vale-presente (só aparece durante a campanha de Natal, ver utils/campanhas.js)
export default function ValePresenteNatal() {
  if (!campanhaNatalAtiva()) return null;
  return (
    <section className="py-16 px-4" style={{ backgroundColor: '#FFF9EE' }}>
      <div className="max-w-3xl mx-auto text-center">
        <div className="text-4xl mb-3">🎁</div>
        <h2 className="text-3xl md:text-4xl font-semibold mb-3" style={{ color: '#2E2C29' }}>Ofereça bem-estar neste Natal</h2>
        <div className="w-12 h-0.5 mx-auto mb-5" style={{ backgroundColor: '#B89547' }}></div>
        <p className="text-base mb-8" style={{ color: '#706b63' }}>
          Um vale-presente da Márcia Monteiro Wellness é um momento de cuidado para quem mais gosta:
          massagens, terapias ou aulas. Fale connosco, escolha o serviço ou o valor e combinamos a entrega.
        </p>
        <a
          href={linkWhatsApp(MENSAGEM_VALE_PRESENTE)}
          onClick={() => registarEvento('clique_whatsapp', { origem: 'secao_vale_presente' })}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-10 py-3 rounded-full text-sm font-semibold shadow-lg transition hover:opacity-90"
          style={{ backgroundColor: '#B89547', color: '#FEFEFD' }}
        >
          Oferecer
        </a>
      </div>
    </section>
  );
}
